import { ModalComponent } from 'src/app/component/modal/modal.component';
import { ApiService } from 'src/app/services/api.service';
import { LoadingService } from 'src/app/services/loading.service';
import { NotificationService } from 'src/app/services/notification/notification.service';

import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Network } from '@awesome-cordova-plugins/network/ngx';
import { SQLite, SQLiteObject } from '@awesome-cordova-plugins/sqlite/ngx';
import { StorageService } from '@core/services';
import { AlertController, ModalController, Platform } from '@ionic/angular';

@Component({
  selector: 'app-users',
  templateUrl: './users.page.html',
  styleUrls: ['./users.page.scss'],
})
export class UsersPage implements OnInit {
  #notificationService = inject(NotificationService);
  stop;
  show = 'bustickets';
  suscribers;
  realtrip;
  tickets;
  isOnline = false;
  type = 'bustickets';
  id: number;

  constructor(
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private network: Network,
    private platform: Platform,
    private sqlite: SQLite,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private storage: StorageService,
    private loadingService: LoadingService
  ) {}

  ngOnInit() {
    if (this.route.snapshot.data['special']) {
      this.stop = this.route.snapshot.data['special'];
    }
    this.storage.get('realtrip').then((realtrip) => {
      if (realtrip) {
        this.realtrip = realtrip;
        this.getBustickets();
        this.getSubscribers();
      } else {
        this.apiService
          .getData('transportec_realtrip')
          .then((res) => {
            console.log('realtrip: ', res);
            if (res && res.realtrip && res.realtrip.id) {
              this.realtrip = res.realtrip;
              this.getBustickets();
              this.getSubscribers();
            }
          })
          .finally(() => {});
      }
    });

    if (this.platform.is('cordova')) {
      this.sqlite.create({ name: 'tecservice.db', location: 'default' }).then((db: SQLiteObject) => {
        // db.executeSql('DROP TABLE IF EXISTS payments', {}).then(() => {});
        // db.executeSql('DROP TABLE users',[]);
        // Users
        db.executeSql(
          'CREATE TABLE IF NOT EXISTS subscriptions (id INTEGER PRIMARY KEY, dotw INTEGER, type TEXT, departure_time TEXT, route_id INTEGER, stop_id INTEGER, bus_id INTEGER, suscription_transportec_id INTEGER)',
          []
        )
          .then(() => {})
          .catch((e) => {
            this.simpleAlert('Error', 'Error SQL: ' + JSON.stringify(e));
            console.log(e);
          });

        db.executeSql(
          'CREATE TABLE IF NOT EXISTS scanned_subscriptions (id INTEGER PRIMARY KEY, realtrip_id INTEGER, scanned_at DATETIME, sent_at DATETIME)',
          []
        )
          .then(() => {})
          .catch((e) => {
            this.simpleAlert('Error', 'Error SQL: ' + JSON.stringify(e));
            console.log(e);
          });

        // db.executeSql('DROP TABLE payments',[]);
        // Pagos
        db.executeSql(
          'CREATE TABLE IF NOT EXISTS bustickets (id INTEGER PRIMARY KEY, amount REAL, method TEXT, scanned_at DATETIME, realtrip_id INTEGER, user_id INTEGER)',
          []
        )
          .then(() => {})
          .catch((e) => {
            this.simpleAlert('Error', 'Error SQL: ' + JSON.stringify(e));
            console.log(e);
          });

        db.executeSql(
          'CREATE TABLE IF NOT EXISTS scanned_bustickets (id INTEGER PRIMARY KEY, realtrip_id INTEGER, scanned_at DATETIME, sent_at DATETIME)',
          []
        )
          .then(() => {})
          .catch((e) => {
            this.simpleAlert('Error', 'Error SQL: ' + JSON.stringify(e));
            console.log(e);
          });
      });
    }

    // watch network for a disconnect
    this.network.onDisconnect().subscribe(() => {
      this.isOnline = false;
    });

    // watch network for a connection
    this.network.onConnect().subscribe(() => {
      if (!this.isOnline) {
        setTimeout(() => {
          /* this.sendToServer();
          this.updateUsers();*/
        }, 3000);
      }
      this.isOnline = true;
    });
  }

  getBustickets() {
    // this.apiService.getData('transportec_bustickets?stop_id=' + this.stop.id + '&realtrip_id=' + this.realtrip.id).then((res) => {
    this.apiService
      .getData('transportec_bustickets?realtrip_id=' + this.realtrip.id)
      .then((res) => {
        console.log('bustickets: ', res);
        this.tickets = res.data;
      })
      .finally(() => {});
  }

  getSubscribers() {
    this.apiService
      .getData('suscribers?realtrip_id=' + this.realtrip.id)
      .then((res) => {
        console.log('suscribers: ', res);
        this.suscribers = res.data;
      })
      .finally(() => {});
  }

  search() {
    if (this.platform.is('cordova')) {
      this.sqlite.create({ name: 'tecservice.db', location: 'default' }).then((db: SQLiteObject) => {
        db.executeSql(
          'SELECT * FROM ' + this.type + ' WHERE id=?' + (this.type === 'bustickets' ? ' AND scanned_at IS NULL' : ''),
          [this.id]
        ).then((data) => {
          const len = data.rows.length;
          // Si existe el boleto o suscripción entonces checamos si no fue previamente escaneado
          if (len > 0) {
            console.log(data.rows.item(0));
            // this.savePayment();
            db.executeSql('SELECT * FROM scanned_' + this.type + ' WHERE id=?', [this.id]).then((data2) => {
              const len2 = data2.rows.length;
              // Si hay resultado quiere decir que ya fue escaneado, entonces rechazamos
              if (len2 > 0) {
                // Existe, no guardar
                console.log(data2.rows.item(0));
                this.busdriverResponse(false);
              } else {
                // No existe, guardar
                this.savePayment();
              }
            });
          } else {
            // No existe
            this.busdriverResponse(false);
          }
        });
      });
    }
  }

  async busdriverResponse(status) {
    if (status) {
      if (this.platform.is('cordova')) {
        // this.simpleAlert("Debug", "go Payment", false);
        if (this.isOnline || this.network.type !== 'none') {
          // this.simpleAlert("Debug", "send", false);
          this.sendPayment();
        } else {
          // this.simpleAlert("Debug", "save", false);
          this.search();
        }
      } else {
        console.log('Enviar pago directo a servidor?');
        this.sendPayment();
      }
    } else {
      this.goModal('error');
    }
  }

  processBusticket(id) {
    this.type = 'bustickets';
    this.id = id;
    this.busdriverResponse(true);
  }

  processSubscription(id) {
    this.type = 'subscriptions';
    this.id = id;
    this.busdriverResponse(true);
  }

  sendPayment() {
    // this.simpleAlert("Debug", "sending..", false);
    const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
    const n = new Date(Date.now() - tzoffset).toISOString().slice(0, 19).replace('T', ' ');
    this.loadingService.present('Validando...');
    setTimeout(() => {
      this.loadingService.dismiss();
    }, 1000);
    this.apiService
      .postData('transportec_' + this.type.slice(0, -1), {
        id: this.id,
        realtrip_id: this.realtrip.id,
        scanned_at: n,
      })
      .then((response) => {
        if (response.success) {
          // this.goModal('success');
          this.savePayment(n);
          this.getBustickets();
          this.getSubscribers();
        } else {
          this.busdriverResponse(false);
          if (response.error) {
            this.#notificationService.presentToast(response.error);
          }
        }
      })
      .catch((error) => {
        this.simpleAlert('Error', 'Error al verificar QR con servidor. Intentar más tarde. Consulte al administrador.');
        this.busdriverResponse(false);
      })
      .finally(() => {
        this.loadingService.dismiss();
      });
  }

  savePayment(sent_at = null) {
    if (this.platform.is('cordova')) {
      // this.simpleAlert("Debug", "saving..", false);
      const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
      const n = new Date(Date.now() - tzoffset).toISOString().slice(0, 19).replace('T', ' ');
      this.loadingService.present('Guardando...');
      setTimeout(() => {
        this.loadingService.dismiss();
      }, 1000);
      this.sqlite
        .create({ name: 'tecservice.db', location: 'default' })
        .then((db: SQLiteObject) => {
          db.executeSql(
            'INSERT OR IGNORE INTO scanned_' + this.type + ' (id, realtrip_id, scanned_at, sent_at) VALUES (?,?,?,?)',
            [this.id, this.realtrip.id, n, sent_at]
          )
            .then((data) => {
              this.goModal('success2');
              this.loadingService.dismiss();
              // this.sendToServer();
            })
            .catch((e) => {
              this.simpleAlert('Error', 'Error: ' + JSON.stringify(e));
              // this.presentToast("INSERT OR IGNORE INTO payments (id, bus_id, route_id, user_id, amount, lat, long, creation_date) VALUES (?,?,?,?,?,?,?,?), [" + null + "," + this.bus.id + "," + this.route.id + "," + this.passenger.id + "," + this.amount + "," + this.lat + "," + this.long + "," + n + "]");
            })
            .finally(() => {
              this.loadingService.dismiss();
            });
        })
        .finally(() => {
          this.loadingService.dismiss();
        });
    } else {
      this.goModal('success2');
    }
  }

  async goModal(type, myContent = null) {
    const modal = await this.modalCtrl.create({
      component: ModalComponent,
      componentProps: {
        has_toolbar: false,
        bg_class: type,
        content: myContent,
      },
      cssClass: 'modal-fullscreen',
      keyboardClose: true,
      showBackdrop: true,
    });

    return await modal.present();
  }

  async simpleAlert(title, message, _closeAfterClick = false) {
    const alert = await this.alertCtrl.create({
      header: title,
      message,
      buttons: [
        {
          text: 'OK',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          },
        },
      ],
    });
    alert.present();
  }
}
